"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyle = exports.hoverBorderColor = exports.borderColor = exports.hoverTextColor = exports.textColor = exports.hoverColor = exports.backgroundColor = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  text-decoration: none;\n  text-align: center;\n  color: ", ";\n  background-color: ", ";\n  ", ";\n  letter-spacing: 0.2px;\n  line-height: 1.36;\n  min-width: ", ";\n  ", ";\n  cursor: ", ";\n  border: solid 1px ", ";\n  transition: all 300ms ease;\n  ", ";\n  ", "\n\n  &:focus {\n    outline: thin dotted;\n    outline: 5px auto #0042CB;\n    outline-offset: -2px;\n    color: #0042CB;\n    background-color: #fff;\n  }\n\n  html.non-touch &:hover {\n    background-color: ", ";\n    border: solid 1px ", ";\n    color: ", ";\n    text-decoration: none;\n\n    ", ";\n  }\n"], ["\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  text-decoration: none;\n  text-align: center;\n  color: ", ";\n  background-color: ", ";\n  ", ";\n  letter-spacing: 0.2px;\n  line-height: 1.36;\n  min-width: ", ";\n  ", ";\n  cursor: ", ";\n  border: solid 1px ", ";\n  transition: all 300ms ease;\n  ", ";\n  ", "\n\n  &:focus {\n    outline: thin dotted;\n    outline: 5px auto #0042CB;\n    outline-offset: -2px;\n    color: #0042CB;\n    background-color: #fff;\n  }\n\n  html.non-touch &:hover {\n    background-color: ", ";\n    border: solid 1px ", ";\n    color: ", ";\n    text-decoration: none;\n\n    ", ";\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["display: ", ";"], ["display: ", ";"]),
    _templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "]),
    _templateObject4 = _taggedTemplateLiteral(["width: 100%;"], ["width: 100%;"]),
    _templateObject5 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border: solid 1px ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      border: solid 1px ", ";\n      color: ", ";\n    "]),
    _templateObject6 = _taggedTemplateLiteral(["\n        div {\n          transform: translateX(4px);\n        }\n      "], ["\n        div {\n          transform: translateX(4px);\n        }\n      "]);

var _buoyTheme = require("buoy-theme");

var _styledComponents = require("styled-components");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var backgroundColor = exports.backgroundColor = function backgroundColor(props) {
  var color = props.backgroundColor || props.color || 'primary';
  if (props.ghost) {
    color = "transparent";
  }

  if (props.disabled && !props.ghost) {
    color = props.color + "Light";
  }

  return props.theme.colors[color];
};

var hoverColor = exports.hoverColor = function hoverColor(props) {
  var color = props.hoverBackgroundColor || props.color + "Dark";

  if (props.ghost && props.disabled) {
    color = "transparent";
  } else if (!props.ghost) {
    if (props.disabled) {
      color = props.color + "Light";
    }
  }

  return props.theme.colors[color];
};

var textColor = exports.textColor = function textColor(props) {
  var color = props.textColor || "white";

  if (props.ghost) {
    if (props.disabled) {
      color = props.color + "Light";
    } else {
      color = props.color;
    }
  }
  return props.theme.colors[color];
};

var hoverTextColor = exports.hoverTextColor = function hoverTextColor(props) {
  var color = props.hoverTextColor || props.textColor || "white";

  if (props.ghost && props.disabled) {
    color = props.color + "Light";
  }
  return props.theme.colors[color];
};

var borderColor = exports.borderColor = function borderColor(props) {
  var color = props.borderColor || props.backgroundColor || props.color;
  if (props.disabled) {
    color = props.color + "Light";
  }

  return props.theme.colors[color];
};

var hoverBorderColor = exports.hoverBorderColor = function hoverBorderColor(props) {
  if (props.hoverBorderColor) {
    return props.theme.colors[props.hoverBorderColor];
  }

  if (props.ghost) {
    return borderColor(props);
  }

  return hoverColor(props);
};

var ButtonStyle = exports.ButtonStyle = (0, _styledComponents.css)(_templateObject, _buoyTheme.fontFamily, function (props) {
  return (0, _buoyTheme.fontSize)(props.large ? "bodyLarge" : "bodyMain")(props);
}, function (props) {
  return props.large ? _buoyTheme.fontWeight.regular(props) : _buoyTheme.fontWeight.light(props);
}, textColor, backgroundColor, function (props) {
  return props.display ? (0, _styledComponents.css)(_templateObject2, props.display) : (0, _styledComponents.css)(_templateObject3);
}, function (props) {
  return props.large ? "210px" : "auto";
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(_templateObject4);
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, borderColor, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.selected && (0, _styledComponents.css)(_templateObject5, hoverColor, hoverBorderColor, hoverTextColor);
}, hoverColor, hoverBorderColor, hoverTextColor, function (props) {
  return props.arrow && (0, _styledComponents.css)(_templateObject6);
});


//////////////////
// WEBPACK FOOTER
// ./~/buoy-button/dist/style.js
// module id = 394
// module chunks = 168707334958949